import { Heading } from '@react-email/components';

const headingFour = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <Heading as="h4" {...attributes} {...element.attributes}>
                {children}
            </Heading>
        );
    },
    PreviewElement: ({ attributes, children }) => {
        return (
            <Heading as="h4" {...attributes}>
                {children}
            </Heading>
        );
    },
};

export default headingFour;
